import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { MibButtonComponent } from '@medinbox/angular';
import { MibLogo } from '../mib-header/mib-logo';

/**
 * User's choice when prompted at session start:
 * - `resume`: keep the context of the previous live (recover after an accidental end);
 * - `new`: start over with a fresh context.
 */
export type ResumeSessionChoice = 'resume' | 'new';

/**
 * Dialog shown at session start to ask whether the user wants to resume the
 * previous live session or start a brand-new one.
 *
 * NOTE: this only implements the popup UI. It is not yet wired into the
 * connection flow — opening it and acting on the returned choice is left to a
 * follow-up.
 */
@Component({
  selector: 'mai-resume-session-dialog',
  imports: [MibLogo, MibButtonComponent],
  templateUrl: './resume-session-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResumeSessionDialog {
  readonly dialogRef = inject(DialogRef<ResumeSessionChoice>);
}
